import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ConfigService, fromMinutesToMilliseconds } from "@obg/ngx.global";
import { CookieService } from "@obg/ngx.global.evo";

@Injectable({
	providedIn: "root",
})
export class GameVariantConfigService {
	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientGaming>,
		private cookieService: CookieService
	) {}

	getCacheMaxAgeForGetGameVariant(): number {
		return fromMinutesToMilliseconds(
			this.configService.get((x) => x.gaming.gameVariant.cacheMaxAge!.getGameVariant, 30)
		);
	}

	getGameVariantEndpoint(): string {
		return this.configService.get(
			(x) => x.gaming.gameVariant.endpoints!.gameVariant,
			"v1/games/:gameId/:variantId"
		);
	}

	shouldUseGameSettings(): boolean {
		if (this.isForceOldGLExperimentEnabled()) return false;
		return (
			this.isShouldUseGameSettingsEnabledWithExperiment() ||
			this.configService.get((x) => x.gaming.gameVariant.shouldUseGameSettings, false)
		);
	}

	isGPT(): boolean {
		if (this.isForceOldGLExperimentEnabled()) return false;
		return (
			this.isShouldUseGameSettingsEnabledWithExperiment() ||
			this.configService.get((x) => x.gaming.gameVariant.shouldUseGameSettings, false)
		);
	}

	getGameSettingsEndpoint(): string {
		return this.configService.get(
			(x) => x.gaming.gameVariant.endpoints!.gameSettings,
			"v1/gameplay/game-settings?gameId=:gameId"
		);
	}

	// todo: API should handle this inconsistency. Some gameVariants are not jurisdiction specific.
	getGameVariantByJurisdictionEndpoint(): string {
		return this.configService.get(
			(x) => x.gaming.gameVariant.endpoints!.gameVariant,
			this.getGameVariantEndpoint()
		);
	}

	private isShouldUseGameSettingsEnabledWithExperiment() {
		const experiments = this.cookieService.get("obg-experiments");
		const isForceGLv2Enabled = !!experiments?.toLowerCase().includes("forceglv2");
		return isForceGLv2Enabled;
	}

	private isForceOldGLExperimentEnabled() {
		const experiments = this.cookieService.get("obg-experiments");
		const isForceOldGL = !!experiments?.toLowerCase().includes("forceoldgl");
		return isForceOldGL;
	}
}
